import { sendRequest } from './rootApi';
import Api from "../constants/Api";

export const forgetPasswordRequest = async (credentials) => {
    return sendRequest("post", Api.forgetPassword, credentials);
}

export const resetPasswordRequest = async (credentials) => { 
    return sendRequest("post", Api.resetPassword, credentials);
}